import SSSlideDisplayer from "./00-slideshare_slide_displayer";

function SSIframeDisplayer(config){
  if (typeof config === "undefined"){
    return;
  }
  SSSlideDisplayer.call(this, config);
}

SSIframeDisplayer.prototype = new SSSlideDisplayer();

SSIframeDisplayer.prototype.start = function(config){
  if (typeof this.slidesContainer === 'undefined'){
    this.slidesContainer = $('.slide_container');
    this.bindEvents();
  }
  if (this.config.playerBgColor){
    this.playerBgColor = this.config.playerBgColor;
  }
  if(this.slides === undefined){
    this.slides = config.slides;
    if(this.slides && this.slides.length > 1){
      this.iframeSlide = this.slides[1];
    }
  }
};

SSIframeDisplayer.prototype.next = function(){
  if(this.iframeSlide){
    this.iframeSlide.next();
  }
};

SSIframeDisplayer.prototype.previous = function(){
  if(this.iframeSlide){
    this.iframeSlide.previous();
  }
};

SSIframeDisplayer.prototype.bindEvents = function(){};

SSIframeDisplayer.prototype.setDimensions = function(){};

SSIframeDisplayer.prototype.emptySlides = function(){};

SSIframeDisplayer.prototype.setPrerenderedSlides = function(){};

SSIframeDisplayer.prototype.showInitializer = function(){};

SSIframeDisplayer.prototype._scrollTo = function(index){};

export default SSIframeDisplayer;
